import SQLSplit from "./SQLSplit";
import constants from "../../../constants";
import { useLocation } from "react-router-dom";
import Profile from "../Home/LandingPage/Profile";
import React, { useContext, useEffect } from "react";
import AlertContext from "../../../context/AlertContext";
import Loading from "../../Notification-Loading/Loading/Loading";
import CodingPageHooks from "../../../Hooks/CodingPage/CodingPageHooks";

export default function SQLPage() {
  const Alert = useContext(AlertContext);

  const { pathname } = useLocation();

  const CodingPgHooks = CodingPageHooks();

  !Alert.isAdmin &&
    (window.onpopstate = () => {
      window.history.pushState({}, "", Alert.navigate("/home"));
    });

  useEffect(() => {
    if (Alert.isTakeTest) {
      CodingPgHooks.setShowingDelay(true);
      CodingPgHooks.ProfileReturn();
    }
  }, [Alert.isTakeTest]);

  useEffect(() => {
    const preventActions = (event) => {
      if (!Alert.isAdmin) {
        event.preventDefault();
        event.stopPropagation();
      }
    };

    document.addEventListener("keydown", (event) => {
      if (!Alert.isAdmin) CodingPgHooks.preventCopyAndCut(event);
    });

    document.addEventListener("drop", preventActions);
    document.addEventListener("paste", preventActions);
    document.addEventListener("dragend", preventActions);
    document.addEventListener("dragover", preventActions);
    document.addEventListener("dragstart", preventActions);
    document.removeEventListener("keyup", (e) =>
      CodingPgHooks.preventCopyAndCut(e)
    );

    document.addEventListener("keydown", (e) => {
      CodingPgHooks.preventCopyAndCut(e);
    });

    return () => {
      document.removeEventListener("drop", preventActions);
      document.removeEventListener("paste", preventActions);
      document.removeEventListener("dragend", preventActions);
      document.removeEventListener("dragover", preventActions);
      document.removeEventListener("dragstart", preventActions);

      document.removeEventListener("keyup", (e) =>
        CodingPgHooks.preventCopyAndCut(e)
      );

      document.removeEventListener("keydown", (e) => {
        CodingPgHooks.preventCopyAndCut(e);
      });
    };
  }, []);

  useEffect(() => {
    const handleKeyPress = (e) => {
      if (
        e.key === "F5" ||
        (e.ctrlKey && e.key === "r") ||
        (e.ctrlKey && e.shiftKey && e.key === "R")
      ) {
        e.preventDefault();
      }
    };

    window.addEventListener("keydown", handleKeyPress);

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, []);

  return (
    <div
      className={
        !Alert.isFullScreen
          ? !pathname.includes("library")
            ? "sqlPageMainContainer"
            : "sqlPageMainContainerForLibrary"
          : "sqlPageMainContainerFullScreen"
      }
    >
      <SQLSplit />
      {Alert.isTakeTest && CodingPgHooks.showingDelay && (
        <Profile
          isTakeTest={Alert.isTakeTest}
          libtypeid={constants.libTypeIds.SQL}
          questionid={Alert.testDetail.data.testid}
        />
      )}
      {Alert.isLoaded && <Loading />}
    </div>
  );
}
